import StreamingIndicator from '@/components/modules/chat/StreamingIndicator'
import MarkdownRenderer from '@/components/shared/MarkdownRenderer'

export default function StreamingBubble({ content }: { content: string }) {
  if (content) return <MarkdownRenderer content={content} />
  return <StreamingIndicator />
}
